function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint-disable jsx-a11y/label-has-for */
import _debounce from 'lodash/debounce';
import React from 'react';
import PropTypes from 'prop-types';
import { SingleDatePicker } from 'react-dates';
import { START_DATE, END_DATE, HORIZONTAL_ORIENTATION, VERTICAL_ORIENTATION } from 'react-dates/constants';
import 'scss/cosmos_date_range.scss';
import { mapTextVariableNameToStaticLocalizedText } from 'js/helpers/localization';

var CosmosDateRange =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CosmosDateRange, _React$Component);

  function CosmosDateRange(props) {
    var _this;

    _classCallCheck(this, CosmosDateRange);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CosmosDateRange).call(this, props));
    _this.state = {};
    _this._onStartDateChange = _this._onStartDateChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._onEndDateChange = _this._onEndDateChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._isOutsideRange = _this._isOutsideRange.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Debouncing fixes the firefox issue where these are called twice in a row really quickly

    _this._onStartDateFocusChange = _debounce(_this._onStartDateFocusChange.bind(_assertThisInitialized(_assertThisInitialized(_this))), 200, {
      leading: true,
      trailing: false
    });
    _this._onEndDateFocusChange = _debounce(_this._onEndDateFocusChange.bind(_assertThisInitialized(_assertThisInitialized(_this))), 200, {
      leading: true,
      trailing: false
    });
    return _this;
  }

  _createClass(CosmosDateRange, [{
    key: "_onStartDateChange",
    value: function _onStartDateChange(startDate) {
      this.props.onDatesChange({
        startDate: startDate
      });
    }
  }, {
    key: "_onEndDateChange",
    value: function _onEndDateChange(endDate) {
      this.props.onDatesChange({
        endDate: endDate
      });
    }
  }, {
    key: "_onStartDateFocusChange",
    value: function _onStartDateFocusChange(_ref) {
      var focused = _ref.focused;
      this.onDateFocusChange(focused ? START_DATE : null); // TODO: or END_DATE? a little weird on mobile
    }
  }, {
    key: "_onEndDateFocusChange",
    value: function _onEndDateFocusChange(_ref2) {
      var focused = _ref2.focused;
      this.onDateFocusChange(focused ? END_DATE : null);
    }
  }, {
    key: "_isOutsideRange",
    value: function _isOutsideRange(momentDate) {
      return this.state.focusedInput === END_DATE && momentDate.isBefore(this.props.startDate, 'day') || this.state.focusedInput === START_DATE && momentDate.isAfter(this.props.endDate, 'day') || this.props.isOutsideRange(momentDate);
    }
  }, {
    key: "onDateFocusChange",
    value: function onDateFocusChange(focusedInput) {
      this.setState({
        focusedInput: focusedInput
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "cosmos-date-range"
      }, React.createElement("label", {
        className: "cosmos-date-range__label-wrapper",
        htmlFor: "cosmos-date-range-".concat(this.props.plotId, "-start-date")
      }, React.createElement(SingleDatePicker, {
        id: "cosmos-date-range-".concat(this.props.plotId, "-start-date"),
        orientation: this.props.isMobileWidth ? VERTICAL_ORIENTATION : HORIZONTAL_ORIENTATION,
        withFullScreenPortal: this.props.isMobileWidth,
        withPortal: !this.props.isMobileWidth,
        focused: this.state.focusedInput === START_DATE,
        initialVisibleMonth: this.props.initialVisibleStartMonth,
        onDateChange: this._onStartDateChange,
        onFocusChange: this._onStartDateFocusChange,
        isOutsideRange: this._isOutsideRange,
        date: this.props.startDate
      })), React.createElement("div", {
        className: "cosmos-date-range__connecting-label cosmos-date-range__label-text"
      }, mapTextVariableNameToStaticLocalizedText('COSMOS_DATE_RANGE_CONNECTING_LABEL')), React.createElement("label", {
        className: "cosmos-date-range__label-wrapper",
        htmlFor: "cosmos-date-range-".concat(this.props.plotId, "-start-date")
      }, React.createElement(SingleDatePicker, {
        id: "cosmos-date-range-".concat(this.props.plotId, "-end-date"),
        orientation: this.props.isMobileWidth ? VERTICAL_ORIENTATION : HORIZONTAL_ORIENTATION,
        withFullScreenPortal: this.props.isMobileWidth,
        withPortal: !this.props.isMobileWidth,
        focused: this.state.focusedInput === END_DATE,
        initialVisibleMonth: this.props.initialVisibleEndMonth,
        onDateChange: this._onEndDateChange,
        onFocusChange: this._onEndDateFocusChange,
        isOutsideRange: this._isOutsideRange,
        date: this.props.endDate
      })));
    }
  }]);

  return CosmosDateRange;
}(React.Component);

CosmosDateRange.propTypes = {
  initialVisibleStartMonth: PropTypes.func.isRequired,
  initialVisibleEndMonth: PropTypes.func.isRequired,
  isOutsideRange: PropTypes.func.isRequired,
  onDatesChange: PropTypes.func.isRequired,
  isMobileWidth: PropTypes.bool.isRequired,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  plotId: PropTypes.string.isRequired
};
export { CosmosDateRange as default };